import * as React from "react";
import { groupBy } from "shared/util/common/util";
import PieChart from "@amzn/awsui-components-react/polaris/pie-chart";
import { Box, Button } from "@amzn/awsui-components-react";
import { RecommendationItem } from "../../calcBusterTypes";
import PropTypes from "prop-types";

const RecommendationsPieChart: React.FC<{
  recommendations: RecommendationItem[];
}> = ({ recommendations }) => {
  const groupedBySeverity = groupBy(recommendations, "severity");
  const data = Object.keys(groupedBySeverity).map((key) => ({
    title: key,
    value: groupedBySeverity[key].length,
  }));

  return (
    <>
      <Box variant="awsui-key-label">Recommendations by Severity</Box>

      <PieChart
        fitHeight
        hideFilter
        hideLegend
        size="small"
        data={data}
        detailPopoverContent={(datum, sum) => [
          { key: datum.title, value: datum.value },
        ]}
        ariaDescription="Pie chart showing how many resources are currently in which state."
        ariaLabel="Pie chart"
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
            <Button>Clear filter</Button>
          </Box>
        }
      />
    </>
  );
};

RecommendationsPieChart.propTypes = {
  recommendations: PropTypes.array.isRequired,
};

export default RecommendationsPieChart;
